module.exports = __webpack_public_path__ + "img/no_order.e6aa4c15.svg";